module.exports = {
      id: "comment-usage",
      viewBox: "0 0 14 15",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#comment",
      toString: function () {
        return this.url;
      }
    }